import React from 'react';
import classnames from 'classnames';
import CurrentBtn from '../../../Schedule/components/CurrentBtn';
import { toFirstUpperCase } from '@gp/utils/common';
import type { IBaseProps } from '@home/types/common';
import './index.scss';

interface ICalendarPanelTopbarProps extends IBaseProps {
  visible?: boolean;
  disabled?: boolean;
  dateType?: ScheduledateTypes;
  currentBtnType?: 0 | -1 | 1;
  onScroll2Current?: () => void;
  left?: React.ReactElement | null;
  right?: React.ReactElement | null;
}

const CalendarPanelTopbar: React.FC<ICalendarPanelTopbarProps> = (props) => {
  const {
    style,
    className,
    visible = false,
    disabled = false,
    dateType = 'quarter',
    currentBtnType = 0,
    onScroll2Current,
    left,
    right,
    isSingLine,
  } = props;

  const hasLeftElement = React.isValidElement(left);

  return (
    <div
      style={style}
      className={classnames('dbg-current-and-sign', className, {
        'has-left-element': hasLeftElement,
        'dbg-current-and-sign-is-sing-line': isSingLine,
      })}
    >
      <div className="dbg-current-and-sign-left">
        {hasLeftElement && left}
        {/* {visible && (
          <>
            <div className="dbg-vertical-divider"></div>
            <CurrentBtn
              disabled={disabled}
              text={`Current ${toFirstUpperCase(dateType)}`}
              type={currentBtnType}
              onClick={onScroll2Current}
            />
          </>
        )} */}
      </div>
      <div className="dbg-current-and-sign-right">{React.isValidElement(right) && right}</div>
    </div>
  );
};

export default React.memo(CalendarPanelTopbar);
